import type { ToAnalyticsItemsProps } from "~/sdk/ga4/types/index"
import { toItemId } from "~/sdk/ga4/transform/itemVariant"

const categoriesToAnalytics = (
    categories: string[],
): Record<`item_category${number | ''}`, string> => {
    return categories.slice(0, 5).reduce((result, category, index) => {
        result[`item_category${index === 0 ? '' : index + 1}`] = category
        return result
    }, {} as Record<`item_category${number | ''}`, string>)
}

export function toAnalyticsItems({ items, view }: ToAnalyticsItemsProps) {
    const analyticsItems = items.map((item) => {
        const categories = categoriesToAnalytics(item.category?.split('>') ?? [])

        return {
            item_id: toItemId(item.inProductGroupWithID, item.sku),
            item_name: item.name,
            item_url: item.url,
            affiliation: item.seller ?? '1',
            coupon: item.coupon ?? '',
            currency: item.extended?.currency ?? 'BRL',
            // Desconto da LINHA (unitário × quantidade): a variável de ecommerce
            // do GTM (GA4) divide `discount` pela quantidade antes de enviar.
            discount: parseFloat(
                (Math.max(0, item.listPrice - item.price) * item.extended.quantity).toFixed(2),
            ),
            index: item.extended.index + 1,
            item_brand: item.brand ?? '',
            item_list_id: view.id,
            item_list_name: view.name,
            item_variant: item.variant ?? '',
            location_id: item.locationID ?? '',
            price: item.price,
            quantity: item.extended.quantity,
            ...categories,
        }
    })

    return analyticsItems
}
